@if (message.Direction == 'UserToBot') {
  <div class="message-container">
    {{ message.Payload.SelectionLabel }}
  </div>
}